export default "__VITE_ASSET__9a3355e9__"